import { graphql } from '@gql';

export const getContentPosts = graphql(/* GraphQL */ `
  query getContentPosts($type: String!, $limit: Int!) {
    all_vildar_content_posts(where: { type: $type }, limit: $limit, order_by: updated_at_DESC) {
      ...ContentPostsListFragment
    }
  }
`);

export const getContentPostByLocale = graphql(/* GraphQL */ `
  query getContentPostByLocale($type: String!, $limit: Int!, $locale: String!, $skip: Int!) {
    all_vildar_content_posts(
      where: { type: $type }
      locale: $locale
      limit: $limit
      skip: $skip
      order_by: updated_at_DESC
    ) {
      ...ContentPostsListFragment
    }
  }
`);

export const getContentPostsByUrlAndType = graphql(/* GraphQL */ `
  query getContentPostsByUrlAndType($type: String!, $limit: Int!, $url: String!, $locale: String!) {
    all_vildar_content_posts(
      where: { type: $type, url: $url }
      locale: $locale
      limit: $limit
      order_by: updated_at_DESC
    ) {
      ...ContentPostsListFragment
    }
  }
`);

export const getContentPostsByUrl = graphql(/* GraphQL */ `
  query getContentPostsByUrl($limit: Int!, $url: String!, $locale: String!) {
    all_vildar_content_posts(where: { url: $url }, locale: $locale, limit: $limit, order_by: updated_at_DESC) {
      ...ContentPostsListFragment
    }
  }
`);

export const ContentPostsListFragment = graphql(/* GraphQL */ `
  fragment ContentPostsListFragment on AllVildarContentPosts {
    total
    items {
      ...ContentPostFragment
    }
  }
`);

export const ImageFragment = graphql(/* GraphQL */ `
  fragment ImageFragment on VildarContentPosts {
    image {
      alt_text
      crop_resize
      gravity
      assetConnection {
        ...SysAssetConnectionFragment
      }
    }
  }
`);

export const ContentPostFragment = graphql(/* GraphQL */ `
  fragment ContentPostFragment on VildarContentPosts {
    __typename
    text
    title
    type
    url
    short_description
    display_title
    date
    show_date
    link_label
    next_post
    ...ImageFragment
    system {
      updated_at
    }
  }
`);
